import { useQuery } from "@tanstack/react-query";
import { getServiceTemplateMetaData } from "../../api/real-cookie-banner.js";
import { useStores } from "../../store/root.js";
import { QueryKeys } from "../../util/query-keys.js";
function useServiceTemplateMetaData(isEnabled = true, refetchOnWindowFocus = false, refetchOnMount = true, filterIdentifiers, includeDeleted = false) {
    const { rcbAuthenticationStore } = useStores();
    const templateMetaQuey = useQuery(QueryKeys.getServiceMeta(filterIdentifiers, includeDeleted), ({ signal })=>{
        return getServiceTemplateMetaData({
            signal,
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            },
            params: {
                filterIdentifiers: filterIdentifiers?.join(",") || "",
                includeDeleted
            }
        });
    }, {
        enabled: isEnabled,
        refetchOnWindowFocus,
        refetchOnMount
    });
    return templateMetaQuey;
}
export { useServiceTemplateMetaData };
